var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lm-template-preview-modal"}},[(_vm.isLoading)?_c('LmComponentLoading'):_vm._e(),_c('b-modal',{attrs:{"id":"emailPreviewModal","title":"Preview Email Template","size":"lg"}},[_c('div',{attrs:{"id":"email-preview"},domProps:{"innerHTML":_vm._s(_vm.htmlEmailTemplateAsString)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }